"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultActionSheet = exports.saveImageByTencentApp = exports.toastDownloadMessage = exports.canDownloadImageByTencentApp = void 0;
var tslib_1 = require("tslib");
var Snackbar_1 = tslib_1.__importDefault(require("../Snackbar"));
var docs_user_agent_1 = tslib_1.__importDefault(require("@tencent/docs-user-agent"));
exports.canDownloadImageByTencentApp = docs_user_agent_1.default.isTencentDocsApp && docs_user_agent_1.default.isTencentDocsAppVersionAboveOrEqual('2.9.2');
function toastDownloadMessage(saveSucceed) {
    if (saveSucceed) {
        Snackbar_1.default.show({
            message: '保存图片成功', duration: 3000, autoClose: true, zIndex: 10003, type: 'success',
        });
    }
    else {
        Snackbar_1.default.show({
            message: '保存图片失败', duration: 3000, autoClose: true, zIndex: 10003, type: 'error',
        });
    }
}
exports.toastDownloadMessage = toastDownloadMessage;
function saveImageByTencentApp(src) {
    if (!exports.canDownloadImageByTencentApp) {
        return;
    }
    if (docs_user_agent_1.default.isAndroid) {
        var jsApi = window.jsApi;
        jsApi && jsApi.invokeNative && jsApi.invokeNative('ui', 'savePublicImg', {
            cmd: 'saveguide',
            content: src,
        }, function (rsp) {
            toastDownloadMessage(rsp.result.errCode === 0);
        });
    }
    else if (docs_user_agent_1.default.isIOS) {
        var mqq = window.mqq;
        mqq && mqq.invoke && mqq.invoke('ui', 'savePublicImg', {
            cmd: 'saveguide',
            content: src,
        }, function (rsp) {
            toastDownloadMessage(rsp.data.errCode === 0);
        });
    }
}
exports.saveImageByTencentApp = saveImageByTencentApp;
function getDefaultActionSheet(imageList) {
    var supportNativeInterface = (docs_user_agent_1.default.isAndroid && window.jsApi && window.jsApi.invokeNative)
        || (docs_user_agent_1.default.isIOS && window.mqq && window.mqq.invoke);
    if (!exports.canDownloadImageByTencentApp || !supportNativeInterface) {
        return null;
    }
    return [{
            id: '保存图片',
            onClick: function (imageIndex) {
                if (exports.canDownloadImageByTencentApp) {
                    saveImageByTencentApp(imageList[imageIndex]);
                }
            },
            disabled: !exports.canDownloadImageByTencentApp,
        }];
}
exports.getDefaultActionSheet = getDefaultActionSheet;
